import styled from "styled-components";

export const OptionDescription = styled.span`
  opacity: 0.54;
`;

export const HandBookLink = styled.div`
  color: ${({ theme: { link } }) => link.color.primary};
  display: inline-flex;
  width: auto;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`;

export const HandBookLinkContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 14px;
`;

export const HandBookLinkItem = styled.div`
  display: inline-flex;
  width: auto;
  margin-bottom: 2px !important;
  max-width: 100%;
`;

export const HandBookLinkSmall = styled(HandBookLink)`
  font-size: 0.75rem;
  white-space: unset;
  word-break: break-all;
`;
